// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__20vze","title":"FrontImage_title__2-ZwY"};